/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Grid2 as Grid,
  TextField,
  MenuItem,
  CircularProgress,
} from "@mui/material";
import AppMessage from "../../components/AppMessage/AppMessage";
import IconDelete from "@mui/icons-material/Delete";
import IconView from "@mui/icons-material/RemoveRedEye";
import CloseIcon from "@mui/icons-material/Close";
import { useDispatch, useSelector } from "react-redux";
import { validate } from "validate.js";
import {
  resetStateAlerts,
  updateAlert,
  submitAlert,
} from "../../app/slices/alertsSlice";
import "./Alerts.css";
import { generateRandomString, getBase64 } from "../../app/utils";
import moment from "moment";

const AlertDialog = ({
  open,
  onClose,
  title,
  selectedAlert,
  method = "VIEW",
  readOnly = false,
}) => {
  const {
    data: dataPut,
    status: statusPut,
    error: errorPut,
  } = useSelector(({ alerts }) => alerts.put);

  const {
    data: dataPost,
    status: statusPost,
    error: errorPost,
  } = useSelector(({ alerts }) => alerts.post);

  const [formValues, setFormValues] = useState(
    selectedAlert ? { ...selectedAlert, _meta: [] } : { _meta: [] }
  );
  const [errors, setErrors] = useState([]);
  const [response, setResponse] = useState(null);
  const [showInput, setShowInput] = useState(true);
  const dispatch = useDispatch();

  const statuses = [
    { value: "A", label: "Active" },
    { value: "I", label: "Inactive" },
  ];

  const schema = {
    title: {
      presence: { allowEmpty: false },
    },
    description: {
      presence: { allowEmpty: false },
    },
    coverImage: {
      presence: { allowEmpty: false },
    },
  };

  const schemaUpdate = {
    title: {
      presence: { allowEmpty: false },
    },
    description: {
      presence: { allowEmpty: false },
    },
    status: {
      presence: { allowEmpty: false },
    },
  };

  const schemaAddReference = {
    referenceTitle: {
      presence: { allowEmpty: false },
    },
    referenceUrl: {
      presence: { allowEmpty: false },
      url: true,
    },
  };

  const schemaAddAttachment = {
    file: {
      presence: { allowEmpty: false },
    },
  };

  //use effect
  useEffect(() => {
    dispatch(resetStateAlerts(["put"]));
    dispatch(resetStateAlerts(["post"]));
    return () => {
      dispatch(resetStateAlerts(["put"]));
      dispatch(resetStateAlerts(["post"]));
    };
  }, []);

  useEffect(() => {
    if (errorPut || errorPost) {
      setResponse({
        type: "error",
        message: errorPost?.message || errorPut?.message || "An error occurred",
      });
    }
  }, [errorPut, errorPost]);

  useEffect(() => {
    if (dataPut || dataPost) {
      setResponse({
        type: "success",
        message: dataPost ? "Alert posted successfully" : dataPut,
      });
      if (method === "ADD") {
        setFormValues({});
      }
    }
  }, [dataPut, dataPost]);

  //methods
  const handleSubmit = async () => {
    let _errors = validate(
      formValues,
      method === "UPDATE" ? schemaUpdate : schema
    );

    if (_errors) {
      setErrors(_errors);
      return;
    } else {
      setErrors([]);
    }

    dispatch(resetStateAlerts(["put"]));
    dispatch(resetStateAlerts(["post"]));

    let _meta = [];
    let _attachments = [];
    let _coverImage = "";

    if (method === "ADD") {
      //push cover image
      _coverImage = `ALT-${moment().format("DDMMYYYY")}-${generateRandomString(
        4
      )}.${formValues?.coverImage?.split(".").pop()}`;

      _meta.push({
        path: "../uploads/alerts/",
        fileName: _coverImage,
        file: formValues?.coverImageBase64,
      });

      //push attachments
      for (let i = 0; i < formValues?.attachments?.length; i++) {
        let _fileName = `ALT-${moment().format(
          "DDMMYYYY"
        )}-${generateRandomString(4)}.${formValues?.attachments[i]?.name
          ?.split(".")
          .pop()}`;

        let bas64 = await getBase64(formValues?.attachments[i]?.file);
        _attachments.push(_fileName);
        _meta.push({
          path: "../uploads/alerts/",
          fileName: _fileName,
          file: bas64,
        });
      }

      let _payload = {
        _meta: _meta,
        cover_image: _coverImage,
        title: formValues?.title,
        description: formValues?.description,
        attachments: _attachments,
        links: formValues?.references || [],
      };

      dispatch(submitAlert(_payload));
    } else if (method === "UPDATE") {
      dispatch(
        updateAlert({
          id: selectedAlert?.alert_id,
          payload: {
            title: formValues?.title,
            description: formValues?.description,
            status: formValues?.status,
            links: formValues?.references || [],
          },
        })
      );
    }
  };

  const handleChange = (e) => {
    const inputName = e?.target?.name;
    const inputValue = e?.target?.value;

    setFormValues({
      ...formValues,
      [inputName]: inputValue,
    });

    if (method === "POST") {
    }
  };

  const addReference = () => {
    let _errors = validate(formValues, schemaAddReference);
    if (_errors) {
      setErrors(_errors);
      return;
    } else {
      setErrors([]);
    }

    let _references = formValues?.references || [];
    _references.push({
      title: formValues?.referenceTitle,
      link: formValues?.referenceUrl,
    });

    setFormValues({
      ...formValues,
      referenceUrl: "",
      referenceTitle: "",
      references: _references,
    });
  };

  const removeReference = (index) => {
    let _references = formValues?.references;

    if (_references[index]) {
      _references.splice(index, 1);
    }

    setFormValues({
      ...formValues,
      references: _references,
    });
  };

  const handleFileChange = async (e) => {
    let inputName = e?.target?.name;

    if (inputName === "coverImage") {
      let coverImageBase64 = await getBase64(e?.target?.files[0]);
      setFormValues({
        ...formValues,
        coverImage: e?.target?.files[0]?.name,
        coverImageFile: e?.target?.files[0],
        coverImageBase64: coverImageBase64,
      });
    } else if ("file") {
      setFormValues({
        ...formValues,
        file: e?.target?.files[0]?.name || "",
        fileActual: e?.target?.files[0],
      });
    }
  };

  const addAttachment = () => {
    let _errors = validate(formValues, schemaAddAttachment);
    if (_errors) {
      setErrors(_errors);
      return;
    } else {
      setErrors([]);
    }

    let _attachments = formValues?.attachments || [];
    _attachments.push({ name: formValues?.file, file: formValues?.fileActual });

    setFormValues({
      ...formValues,
      file: "",
      attachments: _attachments,
    });
    setShowInput(false);
    setTimeout(() => {
      setShowInput(true);
    }, 400);
  };

  const removeAttachment = (index) => {
    let _attachments = formValues?.attachments;

    if (_attachments) {
      _attachments.splice(index, 1);
    }

    setFormValues({
      ...formValues,
      attachments: _attachments,
    });
  };

  //builders
  const BuildForm = () => {
    return (
      <Grid container spacing={2}>
        {formValues.coverImageBase64 && (
          <Grid size={12}>
            <div className="flex-row justify-content-center">
              <img id="alert-cover" src={formValues?.coverImageBase64} alt="" />
            </div>
          </Grid>
        )}
        <Grid item size={{ xs: 12, md: 6 }}>
          <TextField
            disabled={readOnly}
            fullWidth
            required
            variant="outlined"
            type="text"
            name="title"
            error={errors["title"] ? true : false}
            helperText={errors["title"] ? errors.title[0] : null}
            id="title"
            label="Title"
            onChange={handleChange}
            value={formValues?.title}
          />
        </Grid>
        <Grid size={{ md: 6, xs: 12 }}>
          <TextField
            fullWidth
            required
            variant="outlined"
            slotProps={{
              inputLabel: { shrink: true },
              htmlInput: { accept: "image/*" },
            }}
            type="file"
            name="coverImage"
            id="coverImage"
            label="Cover Image"
            error={errors["coverImage"] ? true : false}
            helperText={errors["coverImage"] ? errors.coverImage[0] : null}
            onChange={handleFileChange}
          />
        </Grid>
        {(method === "UPDATE" || method === "VIEW") && (
          <Grid item size={{ xs: 12, md: 6 }}>
            <TextField
              required
              disabled={readOnly}
              fullWidth
              variant="outlined"
              name="status"
              id="incident-rating"
              select
              label="Status"
              error={errors["status"] ? true : false}
              helperText={errors["status"] ? errors.status[0] : null}
              onChange={handleChange}
              value={formValues?.status}
            >
              {statuses.map((option) => {
                return <MenuItem value={option.value}>{option.label}</MenuItem>;
              })}
            </TextField>
          </Grid>
        )}
        <Grid item size={{ xs: 12, md: 12 }}>
          <TextField
            disabled={readOnly}
            fullWidth
            multiline
            rows={readOnly ? 8 : 5}
            required
            variant="outlined"
            type="text"
            name="description"
            error={errors["description"] ? true : false}
            helperText={errors["description"] ? errors.description[0] : null}
            id="description"
            label="Description"
            onChange={handleChange}
            value={formValues?.description}
          />
        </Grid>

        {(method === "PUT" || method === "VIEW") && (
          <Grid item size={{ xs: 12, md: 6 }}>
            <TextField
              required
              disabled={readOnly}
              fullWidth
              variant="outlined"
              name="status"
              id="incident-rating"
              select
              label="Status"
              error={errors["status"] ? true : false}
              helperText={errors["status"] ? errors.status[0] : null}
              onChange={handleChange}
              value={formValues?.status}
            >
              {statuses.map((option) => {
                return <MenuItem value={option.value}>{option.label}</MenuItem>;
              })}
            </TextField>
          </Grid>
        )}

        <Grid item size={12}>
          <div className="p-20 form-darker-section">
            <Grid size={12} spacing={2} container>
              <Grid size={12}>
                <p>Attachments (optional)</p>
              </Grid>
              {!readOnly && showInput && method === "ADD" && (
                <>
                  <Grid item size={{ xs: 12, md: 4 }}>
                    <TextField
                      disabled={readOnly}
                      fullWidth
                      required
                      variant="outlined"
                      slotProps={{
                        inputLabel: { shrink: true },
                        htmlInput: { accept: "application/pdf" },
                      }}
                      type="file"
                      name="file"
                      error={errors["file"] ? true : false}
                      helperText={errors["file"] ? errors.file[0] : null}
                      id="file"
                      label="File"
                      onChange={handleFileChange}
                    />
                  </Grid>

                  <Grid item size={{ xs: 12, md: 4 }}>
                    <Button
                      style={{ marginTop: "5px" }}
                      id="btn-add-attachment"
                      variant="contained"
                      size="small"
                      onClick={addAttachment}
                      color="secondary"
                    >
                      + Add Attachment
                    </Button>
                  </Grid>
                </>
              )}

              <Grid item size={12}>
                {formValues?.attachments?.length > 0 && (
                  <table className="app-simple-table">
                    <thead>
                      <th>File Name</th>
                      {method !== "ADD" && <th>Preview</th>}
                      {!readOnly && method === "ADD" && <th>Remove</th>}
                    </thead>
                    <tbody>
                      {formValues?.attachments?.map((item, index) => (
                        <tr>
                          <td>{item?.name}</td>
                          {method !== "ADD" && (
                            <td>
                              <div className="icon-button">
                                <IconView
                                  color="primary"
                                  onClick={() => {
                                    window.open(
                                      `${process.env.REACT_APP_SERVER_URL}/uploads/alerts/${item.name}`
                                    );
                                  }}
                                />
                              </div>
                            </td>
                          )}
                          {!readOnly && method === "ADD" && (
                            <td>
                              <div className="icon-button">
                                <IconDelete
                                  color="error"
                                  onClick={() => {
                                    removeAttachment(index);
                                  }}
                                />
                              </div>
                            </td>
                          )}
                        </tr>
                      ))}
                    </tbody>
                  </table>
                )}

                {(formValues?.attachments?.length === 0 ||
                  formValues?.attachments === undefined) && (
                  <div className="flex-row p-20 justify-content-center">
                    No attachments added
                  </div>
                )}
              </Grid>
            </Grid>
          </div>

          <div className="p-20 mt-20 form-darker-section">
            <Grid size={12} spacing={2} container>
              <Grid size={12}>
                <p>Reference Links (optional)</p>
              </Grid>
              {!readOnly && (
                <>
                  <Grid item size={{ xs: 12, md: 4 }}>
                    <TextField
                      disabled={readOnly}
                      fullWidth
                      required
                      variant="outlined"
                      type="text"
                      name="referenceTitle"
                      error={errors["referenceTitle"] ? true : false}
                      helperText={
                        errors["referenceTitle"]
                          ? errors.referenceTitle[0]
                          : null
                      }
                      id="referenceTitle"
                      label="Reference Title"
                      onChange={handleChange}
                      value={formValues?.referenceTitle}
                    />
                  </Grid>
                  <Grid item size={{ xs: 12, md: 4 }}>
                    <TextField
                      disabled={readOnly}
                      fullWidth
                      required
                      variant="outlined"
                      type="text"
                      name="referenceUrl"
                      placeholder="https://somelink.ext"
                      error={errors["referenceUrl"] ? true : false}
                      helperText={
                        errors["referenceUrl"] ? errors.referenceUrl[0] : null
                      }
                      id="referenceUrl"
                      label="Reference Link"
                      onChange={handleChange}
                      value={formValues?.referenceUrl}
                    />
                  </Grid>
                  <Grid item size={{ xs: 12, md: 4 }}>
                    <Button
                      style={{ marginTop: "5px" }}
                      id="btn-add-reference"
                      variant="contained"
                      size="small"
                      onClick={() => {
                        addReference();
                      }}
                      color="secondary"
                    >
                      + Add Reference
                    </Button>
                  </Grid>
                </>
              )}

              <Grid item size={12}>
                {formValues?.references?.length > 0 && (
                  <table className="app-simple-table">
                    <thead>
                      <th>Reference Title</th>
                      <th>Reference Link</th>
                      {!readOnly && <th>Remove</th>}
                    </thead>
                    <tbody>
                      {formValues?.references?.map((item, index) => (
                        <tr>
                          <td>{item?.title}</td>
                          <td>{item?.link}</td>
                          {!readOnly && (
                            <td>
                              <div className="icon-button">
                                <IconDelete
                                  color="error"
                                  onClick={() => {
                                    removeReference(index);
                                  }}
                                />
                              </div>
                            </td>
                          )}
                        </tr>
                      ))}
                    </tbody>
                  </table>
                )}
                {(formValues?.references?.length === 0 ||
                  formValues?.references === undefined) && (
                  <div className="flex-row p-20 justify-content-center">
                    No references added
                  </div>
                )}
              </Grid>
            </Grid>
          </div>
        </Grid>
      </Grid>
    );
  };

  return (
    <Dialog
      fullWidth={true}
      maxWidth={"md"}
      disableBackdropClick
      disableEscapeKeyDown
      open={open}
      aria-labelledby="responsive-dialog-title"
    >
      <DialogTitle id="responsive-dialog-title">
        <span id="modal-header">
          <b>{title?.toUpperCase()}</b>
        </span>
      </DialogTitle>
      <DialogContent>
        <DialogContentText>
          <div className="p-10">{BuildForm()}</div>
          {response && (
            <AppMessage
              isOpen={response !== null}
              message={response?.message}
              messageType={response?.type}
              onClose={() => {
                setResponse(null);
              }}
            />
          )}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        {dataPut === null &&
          dataPost === null &&
          (method === "UPDATE" || method === "ADD") && (
            <Button
              id="btn-submit"
              variant="contained"
              size="small"
              disabled={statusPut === "loading" || statusPost === "loading"}
              onClick={() => {
                handleSubmit();
              }}
              color="primary"
            >
              {(statusPut === "loading" || statusPost === "loading") && (
                <CircularProgress
                  size={20}
                  color="white"
                  style={{ marginRight: "5px" }}
                />
              )}
              {method === "ADD" ? "Post" : "Update"}
            </Button>
          )}

        <Button
          id="btn-close"
          variant="contained"
          size="small"
          onClick={() => {
            onClose(dataPut || dataPost ? true : false);
          }}
          color="error"
        >
          <CloseIcon fontSize="small" className="app-button-icon" /> Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AlertDialog;
